import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

//
// components
//
import Switch from 'react-bootstrap-switch';
import FormGroupView from 'PMT/components/form/FormGroupView';

export default class IrlPaymentAllowedView extends Component {

  static propTypes = {
    enabled: PropTypes.bool.isRequired,

    onChange: PropTypes.func.isRequired,

    readOnly: PropTypes.bool.isRequired,
  };

  //
  //
  //

  render() {
    return (
      <FormGroupView>
        <FormGroupView.Label>
          {I18n.tr('order.settings.irl_payment_allowed.title')}
        </FormGroupView.Label>
        <FormGroupView.Content>
          <Switch
            bsSize="mini"
            value={this.props.enabled}
            onChange={() => this.props.onChange(!this.props.enabled)}
            disabled={this.props.readOnly}
          />
        </FormGroupView.Content>
      </FormGroupView>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/pages/order/settings/modes/components/IrlPaymentAllowedView.js